import { Weight } from '../shared/query/model/weight.model';

export class TraitReference {
    constructor(
        public id?: string,
        public name?: string,
        public description?: string,
        public children?: TraitReference[],
        public parent?: TraitReference,
        public selectable?: boolean,
        public collapsed?: boolean
    ) {
    }
}

export class TraitObservation {
    constructor(
        public lineNo: number,
        public gid: number,
        public designation: string,
        public locationId: number,
        public locationName: string,
        public value: String
    ) {
    }
}

export class TraitInfo {
    constructor(
        public id: number,
        public name: string,
        public locationCount: number,
        public germplasmCount: number,
        public observationCount: number,
        public condition: TraitCondition,
        public limits: string,
        public priority: Weight
    ) {
    }
}

export class NumericTraitInfo extends TraitInfo {
    constructor(
        id: number,
        name: string,
        locationCount: number,
        germplasmCount: number,
        observationCount: number,
        limits: string,
        weight: Weight,
        condition: TraitCondition,
        public minValue: number,
        public maxValue: number,
        public medianValue: number
    ) {
        super(id, name, locationCount, germplasmCount, observationCount, condition, limits, weight);
    }
}

export class CharacterTraitInfo extends TraitInfo {
    constructor(
        id: number,
        name: string,
        locationCount: number,
        germplasmCount: number,
        observationCount: number,
        limits: string,
        weight: Weight,
        condition: TraitCondition,
        public values: string[],
    ) {
        super(id, name, locationCount, germplasmCount, observationCount, condition, limits, weight);
    }
}

export class CategoricalValue {
    constructor(
        public id: number,
        public name: string,
        public count: number
    ) {
    }
}

export class CategoricalTraitInfo extends TraitInfo {
    constructor(
        id: number,
        name: string,
        locationCount: number,
        germplasmCount: number,
        observationCount: number,
        limits: string,
        weight: Weight,
        condition: TraitCondition,
        public values: CategoricalValue[],
    ) {
        super(id, name, locationCount, germplasmCount, observationCount, condition, limits, weight);
    }
}

export class TraitFilterRequest {
    constructor(
        public environmentIds: number[],
        public traitIds: number[]
    ) {
    }
}

export class TraitResultRequest {
    constructor(
        public environments: any[],
        public numericTraitFilterDTOList: TraitFilter[],
        public characterTraitFilterDTOList: TraitFilter[],
        public categoricalTraitFilterDTOList: TraitFilter[],
    ) {
    }
}

export class TraitFilter {
    constructor(
        traitInfo: TraitInfo,
        condition: TraitCondition,
        limits: string[]
    ) {
    }
}

export class TraitResultResponse {
    constructor(
        public germplasmId: number,
        public designation: string,
        public combinedScore: number,
        public traitObservations: TraitObservationResult[]
    ) {
    }
}

export class TraitObservationResult {
    constructor(
        public name: string,
        public noOfObs: number,
        public successRatio: number
    ) {
    }
}

export enum TraitCondition {
    DROP_TRAIT = 'DROP_TRAIT',
    KEEP_ALL = 'KEEP_ALL',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
    EQUAL = 'EQUAL',
    GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    BETWEEN = 'BETWEEN',
    IN = 'IN',
    NOT_IN = 'NOT_IN'
}

